module.exports = __webpack_public_path__ + "static/img/superhero_02_preview.330115a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/video/superhero_02_preview.png
// module id = a+fe
// module chunks = 0